import { Form, formProviderHOC } from '@sravni/cosago-react-library/lib/components';
import { useFormContext } from '@sravni/cosago-react-library/lib/hooks';
import type { FormComponentProps } from '@sravni/cosago-react-library/lib/types';
import { Button, Card, Space } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';
import React, { useEffect } from 'react';

import { sendEventValidationError } from 'shared/lib/sendGAEvents';
import type { TCommonAdditionalFormProps } from 'shared/types';

import type { TMfoDataFormFields } from 'entities/creditForm';

import { RefundInfo } from '../components';
import { useMfoFieldsControl } from '../lib/useMfoFieldsControl';

type Props = FormComponentProps<TMfoDataFormFields, TCommonAdditionalFormProps>;

const MfoFullDealFormView = ({ onSubmit, NAMES, submitButtonText, FieldConstructor, isLoading }: Props) => {
  const isMobile = useIsMobile();
  const { formState, watch } = useFormContext();
  const { errors } = formState || {};

  useMfoFieldsControl();

  useEffect(() => {
    if (errors && Object.keys(errors).length > 0) {
      const error = Object.entries(errors).map(([key, value]) => ({ key, message: value?.message }))[0];
      const snils = watch('snils');

      sendEventValidationError({ field: error?.key, reason: error?.message?.toString() || '', value: snils });
    }
  }, [errors, watch]);

  return (
    <>
      <Form.Block>
        <Form.Row colWidths={[6, 6]}>
          <FieldConstructor type={NAMES.amount} />
          <FieldConstructor type={NAMES.period} />
        </Form.Row>
        <Form.Row colWidths={[6]}>
          <FieldConstructor type={NAMES.snils} />
        </Form.Row>
      </Form.Block>
      <Form.Block>
        <Card
          color="blue"
          size={16}
        >
          <Space size={12}>
            <RefundInfo />
            {!isMobile && (
              <Button
                type="submit"
                variant="primary"
                onClick={onSubmit}
                loading={isLoading}
                size={52}
                block
              >
                {submitButtonText}
              </Button>
            )}
          </Space>
        </Card>
      </Form.Block>

      {isMobile && (
        <Form.Block>
          <Button
            className="h-mt"
            type="submit"
            variant="primary"
            onClick={onSubmit}
            loading={isLoading}
            size={52}
            block
          >
            {submitButtonText}
          </Button>
        </Form.Block>
      )}
    </>
  );
};

export const MfoFullDealFormViewHoc = formProviderHOC<TMfoDataFormFields, TCommonAdditionalFormProps>(
  MfoFullDealFormView,
);
